import React, { useEffect, useState } from "react";
import { BtsLogo } from "./BtsLogo";
import { Menu, X } from "lucide-react";

const NAV = [
  { id: "about", label: "About" },
  { id: "services", label: "Services" },
  { id: "corporate", label: "For Corporates" },
  { id: "pricing", label: "Pricing" },
  { id: "faq", label: "FAQ" },
  { id: "contact", label: "Contact" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-header"
      className={`sticky top-0 z-40 border-b border-black/10 bg-white ${
        scrolled ? "shadow-[0_1px_0_0_#0a0a0a]" : ""
      }`}
    >
      <div className="mx-auto max-w-7xl px-5 md:px-10 h-[72px] flex items-center justify-between">
        <button
          data-testid="nav-home"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center"
        >
          <BtsLogo size={36} />
        </button>

        <nav className="hidden md:flex items-center gap-8">
          {NAV.map((n) => (
            <button
              key={n.id}
              data-testid={`nav-${n.id}`}
              onClick={() => go(n.id)}
              className="link-underline text-sm font-semibold text-black"
            >
              {n.label}
            </button>
          ))}
        </nav>

        <div className="hidden md:block">
          <button
            data-testid="header-cta"
            onClick={() => go("contact")}
            className="btn-primary text-sm"
          >
            Book a call
          </button>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden p-2 border border-black"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-black/10 bg-white" data-testid="mobile-menu">
          <div className="px-5 py-4 flex flex-col gap-4">
            {NAV.map((n) => (
              <button
                key={n.id}
                data-testid={`mobile-nav-${n.id}`}
                onClick={() => go(n.id)}
                className="text-left text-base font-semibold"
              >
                {n.label}
              </button>
            ))}
            <button
              data-testid="mobile-header-cta"
              onClick={() => go("contact")}
              className="btn-primary text-sm justify-center"
            >
              Book a call
            </button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
